/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

const sliderNavDots = document.getElementById('hero-slider-nav-dots');

if (sliderNavDots) {
    const sliderNavDotsButtons = sliderNavDots.querySelectorAll('.hero-slider-nav-dot');

    sliderNavDotsButtons.forEach(button => {
        button.addEventListener('click', () => {
            const slideIndex = parseInt(button.getAttribute('data-slide-index'));
            const heroSlider = document.querySelector('.hero-slider');
            const heroImageWrappers = heroSlider.querySelectorAll('.hero-image-wrapper');
            heroImageWrappers.forEach((wrapper, index) => {
                if (index === slideIndex) {
                    wrapper.setAttribute('data-active', 'true');
                } else {
                    wrapper.setAttribute('data-active', 'false');
                }
            });
        });
    });
}

const videoControls = document.querySelector('.video-controls');

const pause = videoControls.querySelector('.pause-button');
const play = videoControls.querySelector('.play-button');

pause.addEventListener('click', () => {
    const video = document.querySelector('video');
    video.pause();
    pause.setAttribute('data-active', 'false');
    play.setAttribute('data-active', 'true');
});

play.addEventListener('click', () => {
    const video = document.querySelector('video');
    video.play();
    pause.setAttribute('data-active', 'true');
    play.setAttribute('data-active', 'false');
});

